import api from './api';

const reviewService = {
  // ============================================
  // PRODUCT REVIEWS
  // ============================================

  // Get reviews for a product
  getProductReviews: (productId) => {
    return api.get(`/products/${productId}/reviews/`);
  },

  // Create a new product review
  createProductReview: (data) => {
    return api.post('/products/reviews/create/', data);
  },

  // Get products the user can review (from delivered orders)
  getReviewableProducts: () => {
    return api.get('/products/reviews/reviewable/');
  },

  // ============================================
  // SERVICE REVIEWS
  // ============================================

  // Get reviews for a service
  getServiceReviews: (serviceId) => {
    return api.get(`/services/${serviceId}/reviews/`);
  },

  // Create a new service review
  createServiceReview: (data) => {
    return api.post('/services/reviews/create/', data);
  },

  // Get services the user can review (from completed appointments)
  getReviewableServices: () => {
    return api.get('/services/reviews/reviewable/');
  },
};

export default reviewService;
